module.exports = __webpack_public_path__ + "img/icon-vehicle-type-m3.5754e7ed.svg";